export const defaultRectOptions = {
  strokeWidth: 2,
  stroke: "red",
  fill: "transparent",
  width: 20,
  height: 20,
  strokeUniform: true,
  noScaleCache: false,
  objectCaching: false
};

export const defaultPolygonOptions = {
  strokeWidth: 2,
  stroke: "red",
  fill: "red",
  strokeUniform: true,
  noScaleCache: false
};

export const defaultLineOptions = {
  strokeWidth: 2,
  fill: 'red',
  stroke: 'red',
  class: 'line',
  originX: 'center',
  originY: 'center',
  selectable: false,
  hasBorders: false,
  hasControls: false,
  evented: false,
  objectCaching:false,
  strokeUniform: true,
  noScaleCache: false
}

export const drawingMode = {
  RECTANGLE: "RECTANGLE",
  POLYGON: "POLYGON"
};
